<template>
  <div>
    <CCard align="center" class="font-lg" >
          <CCardHeader :color="color"
            ><span
              class="text-white text-center font-weight-bolder text-uppercase"
              >{{ title }}</span
            ></CCardHeader
          >
          <CCardBody class="center-div"  v-show="period.length != 0" >
            <span class="text-justify" style="list-style: none">
              <li>
                <i class="fa fa-user-circle mr-2"></i>&nbsp;
                <b>{{ period.users }}</b>
                Users Joined
              </li>
              <li>
                <i class="fa fa-user mr-2"></i>&nbsp;
                <b>{{ period.active_users }}</b>
                Active Users
              </li>
              <li>
                <i class="fa fa-gamepad mr-2"></i>&nbsp;
                <b>{{ period.games }}</b>
                Games Played
              </li>
<!--              <li>
                <i class="fa fa-gamepad mr-2"></i>&nbsp;
                <b>{{ period.bcs_played }}</b>
                BCS Played
              </li>
               <li>
                <i class="fa fa-money mr-2"></i>&nbsp;
                <b>৳ {{ period.bcs_fee }}</b>
                BCS Fee
              </li>
              <li>
                <i class="fa fa-gamepad mr-2"></i>&nbsp;
                <b>{{ period.weekly_played }}</b>
                Weekly Played
              </li>-->
              <li>
                <i class="fa fa-gamepad mr-2"></i>&nbsp;
                <b>{{ period.total_played_challenge_room }}</b>
                Challenge Room Played
              </li>
              <li>
                <i class="fa fa-trophy mr-2"></i>&nbsp;
                <b>{{ period.tournaments }}</b>
                Tournaments Played
              </li>
              <li>
                <i class="fa fa-money mr-2"></i>&nbsp;
                <b> ৳ {{ period.tournament_fee }}</b>
                Tournament Fee
              </li>
              <li>
                <i class="fa fa-chain mr-2"></i>&nbsp;
                <b>{{ period.challenges }}</b>
                Challenges Played
              </li>
              <li>
                <i class="fa fa-gift mr-2"></i>&nbsp;
                <b>{{ period.referrals }}</b>
                Total Referrals
              </li>
              <li>
                <i class="fa fa-clone mr-2"></i>&nbsp; Categories
                Created : <b> {{ period.categories }} </b>
              </li>
              <li>
                <i class="fa fa-archive mr-2"></i>&nbsp; Topics Created :
                <b> {{ period.topics }} </b>
              </li>
              <li>
                <i class="fa fa-question-circle mr-2"></i>&nbsp; Questions
                Created : <b> {{ period.questions }} </b>
              </li>
              <li>
                <i class="fa fa-flag mr-2"></i>&nbsp; Questions Reported :
                <b> {{ period.reported_questions }} </b>
              </li>
              <li>
                <i class="fa fa-check-square mr-2"></i>&nbsp; Questions Resolved :
                <b> {{ period.resolved_questions }} </b>
              </li>
              <li>
                <i class="fa fa-money mr-2"></i>&nbsp;
                <b> ৳ {{ period.bundle_purchased }}</b>
                Bundle Purchased
              </li>
<!--              <li>-->
<!--                <i class="fa fa-diamond mr-2"></i>&nbsp;-->
<!--                <b> {{ period.total_bundle }}</b>-->
<!--                Bundles Purchased-->
<!--              </li>-->
               <li>
                <i class="fa fa-adjust mr-2"></i>&nbsp;
                <b> {{ period.coins_debit }}</b>
                Coin Debit
              </li>
               <li>
                <i class="fa fa-adjust mr-2"></i>&nbsp;
                <b> {{ period.coins_credit }}</b>
                Coin Credit
              </li>
               <li>
                <i class="fa fa-diamond mr-2"></i>&nbsp;
                <b> {{ period.gems_debit }}</b>
               Gems Debit
              </li>
               <li>
                <i class="fa fa-diamond mr-2"></i>&nbsp;
                <b> {{ period.gems_credit }}</b>
               Gems Credit
              </li>
<!--              <li>-->
<!--                <i class="fa fa-spinner mr-2"></i>&nbsp;-->
<!--                <b> {{ period.spins }}</b>-->
<!--                Wheel Spins-->
<!--              </li>-->
<!--              <li>-->
<!--                <i class="fa fa-spinner mr-2"></i>&nbsp;-->
<!--                <b> {{ period.subscription_reward_data_count }}</b>-->
<!--                Data Pack count-->
<!--              </li>-->
<!--              <li>-->
<!--                <i class="fa fa-spinner mr-2"></i>&nbsp;-->
<!--                <b> {{ period.subscription_reward_recharge_count }}</b>-->
<!--                Recharges Cost-->
<!--              </li>-->
            </span>
          </CCardBody>
        </CCard>
  </div>
</template>

<script>
export default {
  name: "DashboardReport",
  created() {},
  data() {
    return {};
  },
  props: ['color','period','title'],
  methods: {},
};
</script>

<style lang="scss" scoped></style>
